/* Reuses the native theme-drawer and search dialog, including focus/scroll management. */
if (!customElements.get('ac-header-shell')) {
  customElements.define('ac-header-shell', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const signal = this.cleanup.signal;
      this.group = this.closest('#header-group');
      this.wrapper = this.closest('.page-wrapper');
      this.previousY = this.scrollY();
      this.mobile = matchMedia('(max-width: 989px)');
      this.addEventListener('click', event => this.handleClick(event), {signal});
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeMenus();
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const open = this.querySelector('details[open]');
          this.closeMenus();
          open?.querySelector('summary')?.focus();
        }
      }, {signal});
      document.addEventListener('scroll', () => this.scheduleScroll(), {capture:true,passive:true,signal});
      window.addEventListener('resize', () => {this.measure();this.previousY=this.scrollY();this.group?.classList.remove('ach-scrolled-away');}, {passive:true,signal});
      this.addEventListener('focusin', () => this.group?.classList.remove('ach-scrolled-away'), {signal});
      for (const name of ['theme-drawer:open','theme-drawer:close']) document.addEventListener(name, event => {
        if (event.target.id !== 'cart-drawer') return;
        this.querySelector('[data-ach-cart]')?.setAttribute('aria-expanded',String(name.endsWith(':open')));
      }, {signal});
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      this.measure();
    }
    disconnectedCallback() {
      this.cleanup?.abort();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);
      this.group?.classList.remove('ach-scrolled-away');
    }
    measure() {
      const height = this.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height',height+'px');
      document.documentElement.style.setProperty('--header-group-height',height+'px');
      document.documentElement.style.setProperty('--top-row-height',(this.querySelector('.ach-bar')?.offsetHeight || height)+'px');
    }
    scrollY() {return Math.max(0,this.wrapper?.scrollTop || window.scrollY || 0);}
    scheduleScroll() {
      if(this.frame)return;
      this.frame=requestAnimationFrame(()=>{this.frame=0;this.updateScroll();});
    }
    updateScroll() {
      const y=this.scrollY(), difference=y-this.previousY;
      if (this.mobile.matches || this.dataset.sticky !== 'scroll-up' || y < this.offsetHeight || this.querySelector('details[open]') || this.querySelector(':focus-visible')) {
        this.group?.classList.remove('ach-scrolled-away');this.previousY=y;return;
      }
      if(Math.abs(difference)<5)return;
      this.group?.classList.toggle('ach-scrolled-away',difference>0);
      this.previousY=y;
    }
    closeMenus() {this.querySelectorAll('details[open]').forEach(el=>el.open=false);}
    async openComponent(id,tag,method,button) {
      const status=this.querySelector('[data-ach-status]');status.hidden=true;
      const target=document.getElementById(id);
      if(!target){status.textContent='Não foi possível abrir agora. Atualize a página e tente novamente.';status.hidden=false;return;}
      button.disabled=true;button.setAttribute('aria-busy','true');
      let timer;
      try {
        await Promise.race([customElements.whenDefined(tag),new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('timeout')),8000);})]);
        this.closeMenus();this.group?.classList.remove('ach-scrolled-away');
        // Restore focusability before the native component captures its return-focus target.
        button.disabled=false;button.focus({preventScroll:true});
        target[method]();
      } catch (_) {
        status.textContent='O carregamento demorou. Tente abrir novamente.';status.hidden=false;
      } finally {clearTimeout(timer);button.disabled=false;button.removeAttribute('aria-busy');}
    }
    handleClick(event) {
      const cart=event.target.closest('[data-ach-cart]');
      if(cart){event.preventDefault();this.openComponent('cart-drawer','theme-drawer','open',cart);return;}
      const search=event.target.closest('[data-ach-search]');
      if(search){event.preventDefault();this.openComponent('search-modal','dialog-component','showDialog',search);return;}
      if(event.target.closest('.ach-mobile-menu a'))this.closeMenus();
    }
  });
}
